<div class="gif-picker">
  <div class="gif-picker-header">
    <input
      type="text"
      [ngModel]="searchQuery()"
      (ngModelChange)="onSearch($event)"
      placeholder="Search GIFs..."
      class="gif-search-input"
    />
    <button class="gif-picker-close" (click)="close()">&#x2715;</button>
  </div>
  <div class="gif-grid">
    @if (loading()) {
      <div class="gif-loading">Searching...</div>
    } @else if (results().length === 0) {
      <div class="gif-loading">No GIFs found</div>
    } @else {
      @for (gif of results(); track trackByGif($index, gif)) {
        <button class="gif-item" (click)="selectGif(gif)" [title]="gif.title">
          <img [src]="gif.preview.url" [alt]="gif.title" loading="lazy" />
        </button>
      }
    }
  </div>
  <div class="gif-attribution">Powered by GIPHY</div>
</div>
